import React from 'react';
import loadable from '@loadable/component';

interface DynamicIconsaxProps {
	iconName: string;
	variant?: 'Linear' | 'Bold' | 'Broken' | 'Bulk' | 'Outline' | 'TwoTone';
	size?: number;
	color?: string;
}

const iconMap: Record<string, () => Promise<any>> = {
	'Aave': () => import('iconsax-react/dist/esm/Aave'),
	'Activity': () => import('iconsax-react/dist/esm/Activity'),
	'Add': () => import('iconsax-react/dist/esm/Add'),
	'AddCircle': () => import('iconsax-react/dist/esm/AddCircle'),
	'AddSquare': () => import('iconsax-react/dist/esm/AddSquare'),
	'Additem': () => import('iconsax-react/dist/esm/Additem'),
	'Airdrop': () => import('iconsax-react/dist/esm/Airdrop'),
	'Airplane': () => import('iconsax-react/dist/esm/Airplane'),
	'AirplaneSquare': () => import('iconsax-react/dist/esm/AirplaneSquare'),
	'Airpod': () => import('iconsax-react/dist/esm/Airpod'),
	'Airpods': () => import('iconsax-react/dist/esm/Airpods'),
	'Alarm': () => import('iconsax-react/dist/esm/Alarm'),
	'AlignBottom': () => import('iconsax-react/dist/esm/AlignBottom'),
	'AlignHorizontally': () => import('iconsax-react/dist/esm/AlignHorizontally'),
	'AlignLeft': () => import('iconsax-react/dist/esm/AlignLeft'),
	'AlignRight': () => import('iconsax-react/dist/esm/AlignRight'),
	'AlignTop': () => import('iconsax-react/dist/esm/AlignTop'),
	'AlignVertically': () => import('iconsax-react/dist/esm/AlignVertically'),
	'Android': () => import('iconsax-react/dist/esm/Android'),
	'Ankr': () => import('iconsax-react/dist/esm/Ankr'),
	'Apple': () => import('iconsax-react/dist/esm/Apple'),
	'Aquarius': () => import('iconsax-react/dist/esm/Aquarius'),
	'Archive': () => import('iconsax-react/dist/esm/Archive'),
	'ArchiveAdd': () => import('iconsax-react/dist/esm/ArchiveAdd'),
	'ArchiveBook': () => import('iconsax-react/dist/esm/ArchiveBook'),
	'ArchiveBox': () => import('iconsax-react/dist/esm/ArchiveBox'),
	'ArchiveMinus': () => import('iconsax-react/dist/esm/ArchiveMinus'),
	'ArchiveSlash': () => import('iconsax-react/dist/esm/ArchiveSlash'),
	'ArchiveTick': () => import('iconsax-react/dist/esm/ArchiveTick'),
	'ArrangeHorizontal': () => import('iconsax-react/dist/esm/ArrangeHorizontal'),
	'ArrangeHorizontalCircle': () => import('iconsax-react/dist/esm/ArrangeHorizontalCircle'),
	'ArrangeHorizontalSquare': () => import('iconsax-react/dist/esm/ArrangeHorizontalSquare'),
	'ArrangeVertical': () => import('iconsax-react/dist/esm/ArrangeVertical'),
	'ArrangeVerticalCircle': () => import('iconsax-react/dist/esm/ArrangeVerticalCircle'),
	'ArrangeVerticalSquare': () => import('iconsax-react/dist/esm/ArrangeVerticalSquare'),
	'Arrow': () => import('iconsax-react/dist/esm/Arrow'),
	'ArrowCircleDown': () => import('iconsax-react/dist/esm/ArrowCircleDown'),
	'ArrowCircleDown2': () => import('iconsax-react/dist/esm/ArrowCircleDown2'),
	'ArrowCircleLeft': () => import('iconsax-react/dist/esm/ArrowCircleLeft'),
	'ArrowCircleLeft2': () => import('iconsax-react/dist/esm/ArrowCircleLeft2'),
	'ArrowCircleRight': () => import('iconsax-react/dist/esm/ArrowCircleRight'),
	'ArrowCircleRight2': () => import('iconsax-react/dist/esm/ArrowCircleRight2'),
	'ArrowCircleUp': () => import('iconsax-react/dist/esm/ArrowCircleUp'),
	'ArrowCircleUp2': () => import('iconsax-react/dist/esm/ArrowCircleUp2'),
	'ArrowDown': () => import('iconsax-react/dist/esm/ArrowDown'),
	'ArrowDown2': () => import('iconsax-react/dist/esm/ArrowDown2'),
	'ArrowDown3': () => import('iconsax-react/dist/esm/ArrowDown3'),
	'ArrowForward': () => import('iconsax-react/dist/esm/ArrowForward'),
	'ArrowForwardSquare': () => import('iconsax-react/dist/esm/ArrowForwardSquare'),
	'ArrowLeft': () => import('iconsax-react/dist/esm/ArrowLeft'),
	'ArrowLeft2': () => import('iconsax-react/dist/esm/ArrowLeft2'),
	'ArrowLeft3': () => import('iconsax-react/dist/esm/ArrowLeft3'),
	'ArrowRight': () => import('iconsax-react/dist/esm/ArrowRight'),
	'ArrowRight2': () => import('iconsax-react/dist/esm/ArrowRight2'),
	'ArrowRight3': () => import('iconsax-react/dist/esm/ArrowRight3'),
	'ArrowRotateLeft': () => import('iconsax-react/dist/esm/ArrowRotateLeft'),
	'ArrowRotateRight': () => import('iconsax-react/dist/esm/ArrowRotateRight'),
	'ArrowSquare': () => import('iconsax-react/dist/esm/ArrowSquare'),
	'ArrowSquareDown': () => import('iconsax-react/dist/esm/ArrowSquareDown'),
	'ArrowSquareLeft': () => import('iconsax-react/dist/esm/ArrowSquareLeft'),
	'ArrowSquareRight': () => import('iconsax-react/dist/esm/ArrowSquareRight'),
	'ArrowSquareUp': () => import('iconsax-react/dist/esm/ArrowSquareUp'),
	'ArrowSwapHorizontal': () => import('iconsax-react/dist/esm/ArrowSwapHorizontal'),
	'ArrowSwapVertical': () => import('iconsax-react/dist/esm/ArrowSwapVertical'),
	'ArrowUp': () => import('iconsax-react/dist/esm/ArrowUp'),
	'ArrowUp2': () => import('iconsax-react/dist/esm/ArrowUp2'),
	'ArrowUp3': () => import('iconsax-react/dist/esm/ArrowUp3'),
	'AttachCircle': () => import('iconsax-react/dist/esm/AttachCircle'),
	'AttachSquare': () => import('iconsax-react/dist/esm/AttachSquare'),
	'AudioSquare': () => import('iconsax-react/dist/esm/AudioSquare'),
	'Augur': () => import('iconsax-react/dist/esm/Augur'),
	'Autobrightness': () => import('iconsax-react/dist/esm/Autobrightness'),
	'Autonio': () => import('iconsax-react/dist/esm/Autonio'),
	'Avalanche': () => import('iconsax-react/dist/esm/Avalanche'),
	'Award': () => import('iconsax-react/dist/esm/Award'),
	'Back': () => import('iconsax-react/dist/esm/Back'),
	'BackSquare': () => import('iconsax-react/dist/esm/BackSquare'),
	'Backward': () => import('iconsax-react/dist/esm/Backward'),
	'Backward10Seconds': () => import('iconsax-react/dist/esm/Backward10Seconds'),
	'Backward15Seconds': () => import('iconsax-react/dist/esm/Backward15Seconds'),
	'Backward5Seconds': () => import('iconsax-react/dist/esm/Backward5Seconds'),
	'BackwardItem': () => import('iconsax-react/dist/esm/BackwardItem'),
	'Bag': () => import('iconsax-react/dist/esm/Bag'),
	'Bag2': () => import('iconsax-react/dist/esm/Bag2'),
	'BagCross': () => import('iconsax-react/dist/esm/BagCross'),
	'BagCross1': () => import('iconsax-react/dist/esm/BagCross1'),
	'BagHappy': () => import('iconsax-react/dist/esm/BagHappy'),
	'BagTick': () => import('iconsax-react/dist/esm/BagTick'),
	'BagTick2': () => import('iconsax-react/dist/esm/BagTick2'),
	'BagTimer': () => import('iconsax-react/dist/esm/BagTimer'),
	'Bank': () => import('iconsax-react/dist/esm/Bank'),
	'Barcode': () => import('iconsax-react/dist/esm/Barcode'),
	'BatteryCharging': () => import('iconsax-react/dist/esm/BatteryCharging'),
	'BatteryDisable': () => import('iconsax-react/dist/esm/BatteryDisable'),
	'BatteryEmpty': () => import('iconsax-react/dist/esm/BatteryEmpty'),
	'BatteryEmpty1': () => import('iconsax-react/dist/esm/BatteryEmpty1'),
	'BatteryFull': () => import('iconsax-react/dist/esm/BatteryFull'),
	'Be': () => import('iconsax-react/dist/esm/Be'),
	'Bezier': () => import('iconsax-react/dist/esm/Bezier'),
	'Bill': () => import('iconsax-react/dist/esm/Bill'),
	'BinanceCoin': () => import('iconsax-react/dist/esm/BinanceCoin'),
	'BinanceUsd': () => import('iconsax-react/dist/esm/BinanceUsd'),
	'Bitcoin': () => import('iconsax-react/dist/esm/Bitcoin'),
	'BitcoinCard': () => import('iconsax-react/dist/esm/BitcoinCard'),
	'BitcoinConvert': () => import('iconsax-react/dist/esm/BitcoinConvert'),
	'BitcoinRefresh': () => import('iconsax-react/dist/esm/BitcoinRefresh'),
	'Blend': () => import('iconsax-react/dist/esm/Blend'),
	'Blend2': () => import('iconsax-react/dist/esm/Blend2'),
	'Blogger': () => import('iconsax-react/dist/esm/Blogger'),
	'Bluetooth': () => import('iconsax-react/dist/esm/Bluetooth'),
	'Bluetooth2': () => import('iconsax-react/dist/esm/Bluetooth2'),
	'BluetoothCircle': () => import('iconsax-react/dist/esm/BluetoothCircle'),
	'BluetoothRectangle': () => import('iconsax-react/dist/esm/BluetoothRectangle'),
	'Blur': () => import('iconsax-react/dist/esm/Blur'),
	'Book': () => import('iconsax-react/dist/esm/Book'),
	'Book1': () => import('iconsax-react/dist/esm/Book1'),
	'BookSaved': () => import('iconsax-react/dist/esm/BookSaved'),
	'BookSquare': () => import('iconsax-react/dist/esm/BookSquare'),
	'Bookmark': () => import('iconsax-react/dist/esm/Bookmark'),
	'Bookmark2': () => import('iconsax-react/dist/esm/Bookmark2'),
	'Bootstrap': () => import('iconsax-react/dist/esm/Bootstrap'),
	'Box': () => import('iconsax-react/dist/esm/Box'),
	'Box1': () => import('iconsax-react/dist/esm/Box1'),
	'Box2': () => import('iconsax-react/dist/esm/Box2'),
	'BoxAdd': () => import('iconsax-react/dist/esm/BoxAdd'),
	'BoxRemove': () => import('iconsax-react/dist/esm/BoxRemove'),
	'BoxSearch': () => import('iconsax-react/dist/esm/BoxSearch'),
	'BoxTick': () => import('iconsax-react/dist/esm/BoxTick'),
	'BoxTime': () => import('iconsax-react/dist/esm/BoxTime'),
	'Briefcase': () => import('iconsax-react/dist/esm/Briefcase'),
	'BrifecaseCross': () => import('iconsax-react/dist/esm/BrifecaseCross'),
	'BrifecaseTick': () => import('iconsax-react/dist/esm/BrifecaseTick'),
	'BrifecaseTimer': () => import('iconsax-react/dist/esm/BrifecaseTimer'),
	'Brodcast': () => import('iconsax-react/dist/esm/Brodcast'),
	'Broom': () => import('iconsax-react/dist/esm/Broom'),
	'Brush': () => import('iconsax-react/dist/esm/Brush'),
	'Brush2': () => import('iconsax-react/dist/esm/Brush2'),
	'Brush3': () => import('iconsax-react/dist/esm/Brush3'),
	'BrushBig': () => import('iconsax-react/dist/esm/BrushBig'),
	'BrushSquare': () => import('iconsax-react/dist/esm/BrushSquare'),
	'Bubble': () => import('iconsax-react/dist/esm/Bubble'),
	'Bucket': () => import('iconsax-react/dist/esm/Bucket'),
	'BucketCircle': () => import('iconsax-react/dist/esm/BucketCircle'),
	'BucketSquare': () => import('iconsax-react/dist/esm/BucketSquare'),
	'Building': () => import('iconsax-react/dist/esm/Building'),
	'Building3': () => import('iconsax-react/dist/esm/Building3'),
	'Building4': () => import('iconsax-react/dist/esm/Building4'),
	'Buildings': () => import('iconsax-react/dist/esm/Buildings'),
	'Buildings2': () => import('iconsax-react/dist/esm/Buildings2'),
	'Buliding': () => import('iconsax-react/dist/esm/Buliding'),
	'Bus': () => import('iconsax-react/dist/esm/Bus'),
	'BuyCrypto': () => import('iconsax-react/dist/esm/BuyCrypto'),
	'Cake': () => import('iconsax-react/dist/esm/Cake'),
	'Calculator': () => import('iconsax-react/dist/esm/Calculator'),
	'Calendar': () => import('iconsax-react/dist/esm/Calendar'),
	'Calendar1': () => import('iconsax-react/dist/esm/Calendar1'),
	'Calendar2': () => import('iconsax-react/dist/esm/Calendar2'),
	'CalendarAdd': () => import('iconsax-react/dist/esm/CalendarAdd'),
	'CalendarCircle': () => import('iconsax-react/dist/esm/CalendarCircle'),
	'CalendarEdit': () => import('iconsax-react/dist/esm/CalendarEdit'),
	'CalendarRemove': () => import('iconsax-react/dist/esm/CalendarRemove'),
	'CalendarSearch': () => import('iconsax-react/dist/esm/CalendarSearch'),
	'CalendarTick': () => import('iconsax-react/dist/esm/CalendarTick'),
	'Call': () => import('iconsax-react/dist/esm/Call'),
	'CallAdd': () => import('iconsax-react/dist/esm/CallAdd'),
	'CallCalling': () => import('iconsax-react/dist/esm/CallCalling'),
	'CallIncoming': () => import('iconsax-react/dist/esm/CallIncoming'),
	'CallMinus': () => import('iconsax-react/dist/esm/CallMinus'),
	'CallOutgoing': () => import('iconsax-react/dist/esm/CallOutgoing'),
	'CallReceived': () => import('iconsax-react/dist/esm/CallReceived'),
	'CallRemove': () => import('iconsax-react/dist/esm/CallRemove'),
	'CallSlash': () => import('iconsax-react/dist/esm/CallSlash'),
	'Camera': () => import('iconsax-react/dist/esm/Camera'),
	'CameraSlash': () => import('iconsax-react/dist/esm/CameraSlash'),
	'Candle': () => import('iconsax-react/dist/esm/Candle'),
	'Candle2': () => import('iconsax-react/dist/esm/Candle2'),
	'Car': () => import('iconsax-react/dist/esm/Car'),
	'Card': () => import('iconsax-react/dist/esm/Card'),
	'CardAdd': () => import('iconsax-react/dist/esm/CardAdd'),
	'CardCoin': () => import('iconsax-react/dist/esm/CardCoin'),
	'CardEdit': () => import('iconsax-react/dist/esm/CardEdit'),
	'CardPos': () => import('iconsax-react/dist/esm/CardPos'),
	'CardReceive': () => import('iconsax-react/dist/esm/CardReceive'),
	'CardRemove': () => import('iconsax-react/dist/esm/CardRemove'),
	'CardRemove1': () => import('iconsax-react/dist/esm/CardRemove1'),
	'CardSend': () => import('iconsax-react/dist/esm/CardSend'),
	'CardSlash': () => import('iconsax-react/dist/esm/CardSlash'),
	'CardTick': () => import('iconsax-react/dist/esm/CardTick'),
	'CardTick1': () => import('iconsax-react/dist/esm/CardTick1'),
	'Cardano': () => import('iconsax-react/dist/esm/Cardano'),
	'Cards': () => import('iconsax-react/dist/esm/Cards'),
	'Category': () => import('iconsax-react/dist/esm/Category'),
	'Category2': () => import('iconsax-react/dist/esm/Category2'),
	'Cd': () => import('iconsax-react/dist/esm/Cd'),
	'Celo': () => import('iconsax-react/dist/esm/Celo'),
	'Celsius': () => import('iconsax-react/dist/esm/Celsius'),
	'Chainlink': () => import('iconsax-react/dist/esm/Chainlink'),
	'Chart': () => import('iconsax-react/dist/esm/Chart'),
	'Chart1': () => import('iconsax-react/dist/esm/Chart1'),
	'Chart2': () => import('iconsax-react/dist/esm/Chart2'),
	'Chart21': () => import('iconsax-react/dist/esm/Chart21'),
	'ChartCircle': () => import('iconsax-react/dist/esm/ChartCircle'),
	'ChartFail': () => import('iconsax-react/dist/esm/ChartFail'),
	'ChartSquare': () => import('iconsax-react/dist/esm/ChartSquare'),
	'ChartSuccess': () => import('iconsax-react/dist/esm/ChartSuccess'),
	'Check': () => import('iconsax-react/dist/esm/Check'),
	'ChemicalGlass': () => import('iconsax-react/dist/esm/ChemicalGlass'),
	'Chrome': () => import('iconsax-react/dist/esm/Chrome'),
	'Civic': () => import('iconsax-react/dist/esm/Civic'),
	'Clipboard': () => import('iconsax-react/dist/esm/Clipboard'),
	'ClipboardClose': () => import('iconsax-react/dist/esm/ClipboardClose'),
	'ClipboardExport': () => import('iconsax-react/dist/esm/ClipboardExport'),
	'ClipboardImport': () => import('iconsax-react/dist/esm/ClipboardImport'),
	'ClipboardText': () => import('iconsax-react/dist/esm/ClipboardText'),
	'ClipboardTick': () => import('iconsax-react/dist/esm/ClipboardTick'),
	'Clock': () => import('iconsax-react/dist/esm/Clock'),
	'CloseCircle': () => import('iconsax-react/dist/esm/CloseCircle'),
	'CloseSquare': () => import('iconsax-react/dist/esm/CloseSquare'),
	'Cloud': () => import('iconsax-react/dist/esm/Cloud'),
	'CloudAdd': () => import('iconsax-react/dist/esm/CloudAdd'),
	'CloudChange': () => import('iconsax-react/dist/esm/CloudChange'),
	'CloudConnection': () => import('iconsax-react/dist/esm/CloudConnection'),
	'CloudCross': () => import('iconsax-react/dist/esm/CloudCross'),
	'CloudDrizzle': () => import('iconsax-react/dist/esm/CloudDrizzle'),
	'CloudFog': () => import('iconsax-react/dist/esm/CloudFog'),
	'CloudLightning': () => import('iconsax-react/dist/esm/CloudLightning'),
	'CloudMinus': () => import('iconsax-react/dist/esm/CloudMinus'),
	'CloudNotif': () => import('iconsax-react/dist/esm/CloudNotif'),
	'CloudPlus': () => import('iconsax-react/dist/esm/CloudPlus'),
	'CloudRemove': () => import('iconsax-react/dist/esm/CloudRemove'),
	'CloudSnow': () => import('iconsax-react/dist/esm/CloudSnow'),
	'CloudSunny': () => import('iconsax-react/dist/esm/CloudSunny'),
	'Code': () => import('iconsax-react/dist/esm/Code'),
	'Code1': () => import('iconsax-react/dist/esm/Code1'),
	'CodeCircle': () => import('iconsax-react/dist/esm/CodeCircle'),
	'Coffee': () => import('iconsax-react/dist/esm/Coffee'),
	'Coin': () => import('iconsax-react/dist/esm/Coin'),
	'Coin1': () => import('iconsax-react/dist/esm/Coin1'),
	'ColorSwatch': () => import('iconsax-react/dist/esm/ColorSwatch'),
	'Colorfilter': () => import('iconsax-react/dist/esm/Colorfilter'),
	'ColorsSquare': () => import('iconsax-react/dist/esm/ColorsSquare'),
	'Command': () => import('iconsax-react/dist/esm/Command'),
	'CommandSquare': () => import('iconsax-react/dist/esm/CommandSquare'),
	'Component': () => import('iconsax-react/dist/esm/Component'),
	'Computing': () => import('iconsax-react/dist/esm/Computing'),
	'Convert': () => import('iconsax-react/dist/esm/Convert'),
	'Convert3DCube': () => import('iconsax-react/dist/esm/Convert3DCube'),
	'ConvertCard': () => import('iconsax-react/dist/esm/ConvertCard'),
	'Convertshape': () => import('iconsax-react/dist/esm/Convertshape'),
	'Convertshape2': () => import('iconsax-react/dist/esm/Convertshape2'),
	'Copy': () => import('iconsax-react/dist/esm/Copy'),
	'CopySuccess': () => import('iconsax-react/dist/esm/CopySuccess'),
	'Copyright': () => import('iconsax-react/dist/esm/Copyright'),
	'Courthouse': () => import('iconsax-react/dist/esm/Courthouse'),
	'Cpu': () => import('iconsax-react/dist/esm/Cpu'),
	'CpuCharge': () => import('iconsax-react/dist/esm/CpuCharge'),
	'CpuSetting': () => import('iconsax-react/dist/esm/CpuSetting'),
	'CreativeCommons': () => import('iconsax-react/dist/esm/CreativeCommons'),
	'Crop': () => import('iconsax-react/dist/esm/Crop'),
	'Crown': () => import('iconsax-react/dist/esm/Crown'),
	'Crown1': () => import('iconsax-react/dist/esm/Crown1'),
	'Cup': () => import('iconsax-react/dist/esm/Cup'),
	'Cut': () => import('iconsax-react/dist/esm/Cut'),
	'Dai': () => import('iconsax-react/dist/esm/Dai'),
	'Danger': () => import('iconsax-react/dist/esm/Danger'),
	'Dash': () => import('iconsax-react/dist/esm/Dash'),
	'Data': () => import('iconsax-react/dist/esm/Data'),
	'Data2': () => import('iconsax-react/dist/esm/Data2'),
	'Decred': () => import('iconsax-react/dist/esm/Decred'),
	'Dent': () => import('iconsax-react/dist/esm/Dent'),
	'Designtools': () => import('iconsax-react/dist/esm/Designtools'),
	'DeviceMessage': () => import('iconsax-react/dist/esm/DeviceMessage'),
	'Devices': () => import('iconsax-react/dist/esm/Devices'),
	'Diagram': () => import('iconsax-react/dist/esm/Diagram'),
	'Diamonds': () => import('iconsax-react/dist/esm/Diamonds'),
	'Direct': () => import('iconsax-react/dist/esm/Direct'),
	'DirectDown': () => import('iconsax-react/dist/esm/DirectDown'),
	'DirectInbox': () => import('iconsax-react/dist/esm/DirectInbox'),
	'DirectLeft': () => import('iconsax-react/dist/esm/DirectLeft'),
	'DirectNormal': () => import('iconsax-react/dist/esm/DirectNormal'),
	'DirectNotification': () => import('iconsax-react/dist/esm/DirectNotification'),
	'DirectRight': () => import('iconsax-react/dist/esm/DirectRight'),
	'DirectSend': () => import('iconsax-react/dist/esm/DirectSend'),
	'DirectUp': () => import('iconsax-react/dist/esm/DirectUp'),
	'DirectboxDefault': () => import('iconsax-react/dist/esm/DirectboxDefault'),
	'DirectboxNotif': () => import('iconsax-react/dist/esm/DirectboxNotif'),
	'DirectboxReceive': () => import('iconsax-react/dist/esm/DirectboxReceive'),
	'DirectboxSend': () => import('iconsax-react/dist/esm/DirectboxSend'),
	'DiscountCircle': () => import('iconsax-react/dist/esm/DiscountCircle'),
	'DiscountShape': () => import('iconsax-react/dist/esm/DiscountShape'),
	'Discover': () => import('iconsax-react/dist/esm/Discover'),
	'Dislike': () => import('iconsax-react/dist/esm/Dislike'),
	'Document': () => import('iconsax-react/dist/esm/Document'),
	'DocumentCloud': () => import('iconsax-react/dist/esm/DocumentCloud'),
	'DocumentCode': () => import('iconsax-react/dist/esm/DocumentCode'),
	'DocumentCode2': () => import('iconsax-react/dist/esm/DocumentCode2'),
	'DocumentCopy': () => import('iconsax-react/dist/esm/DocumentCopy'),
	'DocumentDownload': () => import('iconsax-react/dist/esm/DocumentDownload'),
	'DocumentFavorite': () => import('iconsax-react/dist/esm/DocumentFavorite'),
	'DocumentFilter': () => import('iconsax-react/dist/esm/DocumentFilter'),
	'DocumentForward': () => import('iconsax-react/dist/esm/DocumentForward'),
	'DocumentLike': () => import('iconsax-react/dist/esm/DocumentLike'),
	'DocumentPrevious': () => import('iconsax-react/dist/esm/DocumentPrevious'),
	'DocumentSketch': () => import('iconsax-react/dist/esm/DocumentSketch'),
	'DocumentText': () => import('iconsax-react/dist/esm/DocumentText'),
	'DocumentText1': () => import('iconsax-react/dist/esm/DocumentText1'),
	'DocumentUpload': () => import('iconsax-react/dist/esm/DocumentUpload'),
	'DollarCircle': () => import('iconsax-react/dist/esm/DollarCircle'),
	'DollarSquare': () => import('iconsax-react/dist/esm/DollarSquare'),
	'Dribbble': () => import('iconsax-react/dist/esm/Dribbble'),
	'Driver': () => import('iconsax-react/dist/esm/Driver'),
	'Driver2': () => import('iconsax-react/dist/esm/Driver2'),
	'DriverRefresh': () => import('iconsax-react/dist/esm/DriverRefresh'),
	'Driving': () => import('iconsax-react/dist/esm/Driving'),
	'Drop': () => import('iconsax-react/dist/esm/Drop'),
	'Dropbox': () => import('iconsax-react/dist/esm/Dropbox'),
	'Edit': () => import('iconsax-react/dist/esm/Edit'),
	'Edit2': () => import('iconsax-react/dist/esm/Edit2'),
	'Educare': () => import('iconsax-react/dist/esm/Educare'),
	'Electricity': () => import('iconsax-react/dist/esm/Electricity'),
	'Element': () => import('iconsax-react/dist/esm/Element'),
	'Element2': () => import('iconsax-react/dist/esm/Element2'),
	'Element3': () => import('iconsax-react/dist/esm/Element3'),
	'Element4': () => import('iconsax-react/dist/esm/Element4'),
	'ElementEqual': () => import('iconsax-react/dist/esm/ElementEqual'),
	'ElementPlus': () => import('iconsax-react/dist/esm/ElementPlus'),
	'Emercoin': () => import('iconsax-react/dist/esm/Emercoin'),
	'EmojiHappy': () => import('iconsax-react/dist/esm/EmojiHappy'),
	'EmojiNormal': () => import('iconsax-react/dist/esm/EmojiNormal'),
	'EmojiSad': () => import('iconsax-react/dist/esm/EmojiSad'),
	'EmptyWallet': () => import('iconsax-react/dist/esm/EmptyWallet'),
	'EmptyWalletAdd': () => import('iconsax-react/dist/esm/EmptyWalletAdd'),
	'EmptyWalletChange': () => import('iconsax-react/dist/esm/EmptyWalletChange'),
	'EmptyWalletRemove': () => import('iconsax-react/dist/esm/EmptyWalletRemove'),
	'EmptyWalletTick': () => import('iconsax-react/dist/esm/EmptyWalletTick'),
	'EmptyWalletTime': () => import('iconsax-react/dist/esm/EmptyWalletTime'),
	'EnjinCoin': () => import('iconsax-react/dist/esm/EnjinCoin'),
	'Eos': () => import('iconsax-react/dist/esm/Eos'),
	'Eraser': () => import('iconsax-react/dist/esm/Eraser'),
	'EraserSquare': () => import('iconsax-react/dist/esm/EraserSquare'),
	'Ethereum': () => import('iconsax-react/dist/esm/Ethereum'),
	'EthereumClassic': () => import('iconsax-react/dist/esm/EthereumClassic'),
	'Export': () => import('iconsax-react/dist/esm/Export'),
	'ExportCircle': () => import('iconsax-react/dist/esm/ExportCircle'),
	'ExportCurve': () => import('iconsax-react/dist/esm/ExportCurve'),
	'ExportSquare': () => import('iconsax-react/dist/esm/ExportSquare'),
	'ExternalDrive': () => import('iconsax-react/dist/esm/ExternalDrive'),
	'Eye': () => import('iconsax-react/dist/esm/Eye'),
	'EyeSlash': () => import('iconsax-react/dist/esm/EyeSlash'),
	'Facebook': () => import('iconsax-react/dist/esm/Facebook'),
	'Fatrows': () => import('iconsax-react/dist/esm/Fatrows'),
	'FavoriteChart': () => import('iconsax-react/dist/esm/FavoriteChart'),
	'Figma': () => import('iconsax-react/dist/esm/Figma'),
	'Figma1': () => import('iconsax-react/dist/esm/Figma1'),
	'Filter': () => import('iconsax-react/dist/esm/Filter'),
	'FilterAdd': () => import('iconsax-react/dist/esm/FilterAdd'),
	'FilterEdit': () => import('iconsax-react/dist/esm/FilterEdit'),
	'FilterRemove': () => import('iconsax-react/dist/esm/FilterRemove'),
	'FilterSearch': () => import('iconsax-react/dist/esm/FilterSearch'),
	'FilterSquare': () => import('iconsax-react/dist/esm/FilterSquare'),
	'FilterTick': () => import('iconsax-react/dist/esm/FilterTick'),
	'FingerCricle': () => import('iconsax-react/dist/esm/FingerCricle'),
	'FingerScan': () => import('iconsax-react/dist/esm/FingerScan'),
	'Firstline': () => import('iconsax-react/dist/esm/Firstline'),
	'Flag': () => import('iconsax-react/dist/esm/Flag'),
	'Flag2': () => import('iconsax-react/dist/esm/Flag2'),
	'Flash': () => import('iconsax-react/dist/esm/Flash'),
	'FlashCircle': () => import('iconsax-react/dist/esm/FlashCircle'),
	'FlashSlash': () => import('iconsax-react/dist/esm/FlashSlash'),
	'Flashy': () => import('iconsax-react/dist/esm/Flashy'),
	'Folder': () => import('iconsax-react/dist/esm/Folder'),
	'Folder2': () => import('iconsax-react/dist/esm/Folder2'),
	'FolderAdd': () => import('iconsax-react/dist/esm/FolderAdd'),
	'FolderCloud': () => import('iconsax-react/dist/esm/FolderCloud'),
	'FolderConnection': () => import('iconsax-react/dist/esm/FolderConnection'),
	'FolderCross': () => import('iconsax-react/dist/esm/FolderCross'),
	'FolderFavorite': () => import('iconsax-react/dist/esm/FolderFavorite'),
	'FolderMinus': () => import('iconsax-react/dist/esm/FolderMinus'),
	'FolderOpen': () => import('iconsax-react/dist/esm/FolderOpen'),
	'Forbidden': () => import('iconsax-react/dist/esm/Forbidden'),
	'Forbidden2': () => import('iconsax-react/dist/esm/Forbidden2'),
	'FormatCircle': () => import('iconsax-react/dist/esm/FormatCircle'),
	'FormatSquare': () => import('iconsax-react/dist/esm/FormatSquare'),
	'Forward': () => import('iconsax-react/dist/esm/Forward'),
	'Forward10Seconds': () => import('iconsax-react/dist/esm/Forward10Seconds'),
	'Forward15Seconds': () => import('iconsax-react/dist/esm/Forward15Seconds'),
	'Forward5Seconds': () => import('iconsax-react/dist/esm/Forward5Seconds'),
	'ForwardItem': () => import('iconsax-react/dist/esm/ForwardItem'),
	'Framer': () => import('iconsax-react/dist/esm/Framer'),
	'FtxToken': () => import('iconsax-react/dist/esm/FtxToken'),
	'Gallery': () => import('iconsax-react/dist/esm/Gallery'),
	'GalleryAdd': () => import('iconsax-react/dist/esm/GalleryAdd'),
	'GalleryEdit': () => import('iconsax-react/dist/esm/GalleryEdit'),
	'GalleryExport': () => import('iconsax-react/dist/esm/GalleryExport'),
	'GalleryFavorite': () => import('iconsax-react/dist/esm/GalleryFavorite'),
	'GalleryImport': () => import('iconsax-react/dist/esm/GalleryImport'),
	'GalleryRemove': () => import('iconsax-react/dist/esm/GalleryRemove'),
	'GallerySlash': () => import('iconsax-react/dist/esm/GallerySlash'),
	'GalleryTick': () => import('iconsax-react/dist/esm/GalleryTick'),
	'Game': () => import('iconsax-react/dist/esm/Game'),
	'Gameboy': () => import('iconsax-react/dist/esm/Gameboy'),
	'GasStation': () => import('iconsax-react/dist/esm/GasStation'),
	'Gemini': () => import('iconsax-react/dist/esm/Gemini'),
	'Gemini2': () => import('iconsax-react/dist/esm/Gemini2'),
	'Ghost': () => import('iconsax-react/dist/esm/Ghost'),
	'Gift': () => import('iconsax-react/dist/esm/Gift'),
	'Glass': () => import('iconsax-react/dist/esm/Glass'),
	'Global': () => import('iconsax-react/dist/esm/Global'),
	'GlobalEdit': () => import('iconsax-react/dist/esm/GlobalEdit'),
	'GlobalRefresh': () => import('iconsax-react/dist/esm/GlobalRefresh'),
	'GlobalSearch': () => import('iconsax-react/dist/esm/GlobalSearch'),
	'Google': () => import('iconsax-react/dist/esm/Google'),
	'GoogleDrive': () => import('iconsax-react/dist/esm/GoogleDrive'),
	'GooglePlay': () => import('iconsax-react/dist/esm/GooglePlay'),
	'Gps': () => import('iconsax-react/dist/esm/Gps'),
	'GpsSlash': () => import('iconsax-react/dist/esm/GpsSlash'),
	'Grammerly': () => import('iconsax-react/dist/esm/Grammerly'),
	'Graph': () => import('iconsax-react/dist/esm/Graph'),
	'Grid1': () => import('iconsax-react/dist/esm/Grid1'),
	'Grid2': () => import('iconsax-react/dist/esm/Grid2'),
	'Grid3': () => import('iconsax-react/dist/esm/Grid3'),
	'Grid4': () => import('iconsax-react/dist/esm/Grid4'),
	'Grid5': () => import('iconsax-react/dist/esm/Grid5'),
	'Grid6': () => import('iconsax-react/dist/esm/Grid6'),
	'Grid7': () => import('iconsax-react/dist/esm/Grid7'),
	'Grid8': () => import('iconsax-react/dist/esm/Grid8'),
	'Grid9': () => import('iconsax-react/dist/esm/Grid9'),
	'GridEdit': () => import('iconsax-react/dist/esm/GridEdit'),
	'GridEraser': () => import('iconsax-react/dist/esm/GridEraser'),
	'GridLock': () => import('iconsax-react/dist/esm/GridLock'),
	'HambergerMenu': () => import('iconsax-react/dist/esm/HambergerMenu'),
	'Happyemoji': () => import('iconsax-react/dist/esm/Happyemoji'),
	'Harmony': () => import('iconsax-react/dist/esm/Harmony'),
	'Hashtag': () => import('iconsax-react/dist/esm/Hashtag'),
	'HashtagDown': () => import('iconsax-react/dist/esm/HashtagDown'),
	'HashtagSquare': () => import('iconsax-react/dist/esm/HashtagSquare'),
	'HashtagUp': () => import('iconsax-react/dist/esm/HashtagUp'),
	'Headphone': () => import('iconsax-react/dist/esm/Headphone'),
	'Headphones': () => import('iconsax-react/dist/esm/Headphones'),
	'Health': () => import('iconsax-react/dist/esm/Health'),
	'Heart': () => import('iconsax-react/dist/esm/Heart'),
	'HeartAdd': () => import('iconsax-react/dist/esm/HeartAdd'),
	'HeartCircle': () => import('iconsax-react/dist/esm/HeartCircle'),
	'HeartEdit': () => import('iconsax-react/dist/esm/HeartEdit'),
	'HeartRemove': () => import('iconsax-react/dist/esm/HeartRemove'),
	'HeartSearch': () => import('iconsax-react/dist/esm/HeartSearch'),
	'HeartSlash': () => import('iconsax-react/dist/esm/HeartSlash'),
	'HeartTick': () => import('iconsax-react/dist/esm/HeartTick'),
	'HederaHashgraph': () => import('iconsax-react/dist/esm/HederaHashgraph'),
	'Hex': () => import('iconsax-react/dist/esm/Hex'),
	'Hierarchy': () => import('iconsax-react/dist/esm/Hierarchy'),
	'Hierarchy2': () => import('iconsax-react/dist/esm/Hierarchy2'),
	'Hierarchy3': () => import('iconsax-react/dist/esm/Hierarchy3'),
	'HierarchySquare': () => import('iconsax-react/dist/esm/HierarchySquare'),
	'HierarchySquare2': () => import('iconsax-react/dist/esm/HierarchySquare2'),
	'HierarchySquare3': () => import('iconsax-react/dist/esm/HierarchySquare3'),
	'Home': () => import('iconsax-react/dist/esm/Home'),
	'Home2': () => import('iconsax-react/dist/esm/Home2'),
	'Home3': () => import('iconsax-react/dist/esm/Home3'),
	'HomeHashtag': () => import('iconsax-react/dist/esm/HomeHashtag'),
	'HomeTrendDown': () => import('iconsax-react/dist/esm/HomeTrendDown'),
	'HomeTrendUp': () => import('iconsax-react/dist/esm/HomeTrendUp'),
	'HomeWifi': () => import('iconsax-react/dist/esm/HomeWifi'),
	'Hospital': () => import('iconsax-react/dist/esm/Hospital'),
	'House': () => import('iconsax-react/dist/esm/House'),
	'House2': () => import('iconsax-react/dist/esm/House2'),
	'Html3': () => import('iconsax-react/dist/esm/Html3'),
	'Html5': () => import('iconsax-react/dist/esm/Html5'),
	'HuobiToken': () => import('iconsax-react/dist/esm/HuobiToken'),
	'I24Support': () => import('iconsax-react/dist/esm/I24Support'),
	'I3DCubeScan': () => import('iconsax-react/dist/esm/I3DCubeScan'),
	'I3DRotate': () => import('iconsax-react/dist/esm/I3DRotate'),
	'I3DSquare': () => import('iconsax-react/dist/esm/I3DSquare'),
	'I3Dcube': () => import('iconsax-react/dist/esm/I3Dcube'),
	'I3Square': () => import('iconsax-react/dist/esm/I3Square'),
	'Icon': () => import('iconsax-react/dist/esm/Icon'),
	'Illustrator': () => import('iconsax-react/dist/esm/Illustrator'),
	'Image': () => import('iconsax-react/dist/esm/Image'),
	'Import': () => import('iconsax-react/dist/esm/Import'),
	'ImportCircle': () => import('iconsax-react/dist/esm/ImportCircle'),
	'ImportCurve': () => import('iconsax-react/dist/esm/ImportCurve'),
	'ImportSquare': () => import('iconsax-react/dist/esm/ImportSquare'),
	'InfoCircle': () => import('iconsax-react/dist/esm/InfoCircle'),
	'Information': () => import('iconsax-react/dist/esm/Information'),
	'Instagram': () => import('iconsax-react/dist/esm/Instagram'),
	'Iost': () => import('iconsax-react/dist/esm/Iost'),
	'JavaScript': () => import('iconsax-react/dist/esm/JavaScript'),
	'Js': () => import('iconsax-react/dist/esm/Js'),
	'Judge': () => import('iconsax-react/dist/esm/Judge'),
	'Kanban': () => import('iconsax-react/dist/esm/Kanban'),
	'Key': () => import('iconsax-react/dist/esm/Key'),
	'KeySquare': () => import('iconsax-react/dist/esm/KeySquare'),
	'Keyboard': () => import('iconsax-react/dist/esm/Keyboard'),
	'KeyboardOpen': () => import('iconsax-react/dist/esm/KeyboardOpen'),
	'KyberNetwork': () => import('iconsax-react/dist/esm/KyberNetwork'),
	'Lamp': () => import('iconsax-react/dist/esm/Lamp'),
	'LampCharge': () => import('iconsax-react/dist/esm/LampCharge'),
	'LampOn': () => import('iconsax-react/dist/esm/LampOn'),
	'LampSlash': () => import('iconsax-react/dist/esm/LampSlash'),
	'LanguageCircle': () => import('iconsax-react/dist/esm/LanguageCircle'),
	'LanguageSquare': () => import('iconsax-react/dist/esm/LanguageSquare'),
	'Layer': () => import('iconsax-react/dist/esm/Layer'),
	'LayoutMaximize': () => import('iconsax-react/dist/esm/LayoutMaximize'),
	'Level': () => import('iconsax-react/dist/esm/Level'),
	'Lifebuoy': () => import('iconsax-react/dist/esm/Lifebuoy'),
	'Like': () => import('iconsax-react/dist/esm/Like'),
	'Like1': () => import('iconsax-react/dist/esm/Like1'),
	'LikeDislike': () => import('iconsax-react/dist/esm/LikeDislike'),
	'LikeShapes': () => import('iconsax-react/dist/esm/LikeShapes'),
	'LikeTag': () => import('iconsax-react/dist/esm/LikeTag'),
	'Link': () => import('iconsax-react/dist/esm/Link'),
	'Link1': () => import('iconsax-react/dist/esm/Link1'),
	'Link2': () => import('iconsax-react/dist/esm/Link2'),
	'Link21': () => import('iconsax-react/dist/esm/Link21'),
	'LinkCircle': () => import('iconsax-react/dist/esm/LinkCircle'),
	'LinkSquare': () => import('iconsax-react/dist/esm/LinkSquare'),
	'Litecoin': () => import('iconsax-react/dist/esm/Litecoin'),
	'Location': () => import('iconsax-react/dist/esm/Location'),
	'LocationAdd': () => import('iconsax-react/dist/esm/LocationAdd'),
	'LocationCross': () => import('iconsax-react/dist/esm/LocationCross'),
	'LocationDiscover': () => import('iconsax-react/dist/esm/LocationDiscover'),
	'LocationMinus': () => import('iconsax-react/dist/esm/LocationMinus'),
	'LocationSlash': () => import('iconsax-react/dist/esm/LocationSlash'),
	'LocationTick': () => import('iconsax-react/dist/esm/LocationTick'),
	'Lock': () => import('iconsax-react/dist/esm/Lock'),
	'Lock1': () => import('iconsax-react/dist/esm/Lock1'),
	'LockCircle': () => import('iconsax-react/dist/esm/LockCircle'),
	'LockSlash': () => import('iconsax-react/dist/esm/LockSlash'),
	'Login': () => import('iconsax-react/dist/esm/Login'),
	'LoginCurve': () => import('iconsax-react/dist/esm/LoginCurve'),
	'Logout': () => import('iconsax-react/dist/esm/Logout'),
	'LogoutCurve': () => import('iconsax-react/dist/esm/LogoutCurve'),
	'Lovely': () => import('iconsax-react/dist/esm/Lovely'),
	'MagicStar': () => import('iconsax-react/dist/esm/MagicStar'),
	'Magicpen': () => import('iconsax-react/dist/esm/Magicpen'),
	'MainComponent': () => import('iconsax-react/dist/esm/MainComponent'),
	'Maker': () => import('iconsax-react/dist/esm/Maker'),
	'Man': () => import('iconsax-react/dist/esm/Man'),
	'Map': () => import('iconsax-react/dist/esm/Map'),
	'Map1': () => import('iconsax-react/dist/esm/Map1'),
	'Mask': () => import('iconsax-react/dist/esm/Mask'),
	'MaskLeft': () => import('iconsax-react/dist/esm/MaskLeft'),
	'MaskRight': () => import('iconsax-react/dist/esm/MaskRight'),
	'Math': () => import('iconsax-react/dist/esm/Math'),
	'Maximize': () => import('iconsax-react/dist/esm/Maximize'),
	'Maximize1': () => import('iconsax-react/dist/esm/Maximize1'),
	'Maximize2': () => import('iconsax-react/dist/esm/Maximize2'),
	'Maximize3': () => import('iconsax-react/dist/esm/Maximize3'),
	'Maximize4': () => import('iconsax-react/dist/esm/Maximize4'),
	'MaximizeCircle': () => import('iconsax-react/dist/esm/MaximizeCircle'),
	'Medal': () => import('iconsax-react/dist/esm/Medal'),
	'MedalStar': () => import('iconsax-react/dist/esm/MedalStar'),
	'Menu': () => import('iconsax-react/dist/esm/Menu'),
	'MenuBoard': () => import('iconsax-react/dist/esm/MenuBoard'),
	'Message': () => import('iconsax-react/dist/esm/Message'),
	'Message2': () => import('iconsax-react/dist/esm/Message2'),
	'MessageAdd': () => import('iconsax-react/dist/esm/MessageAdd'),
	'MessageAdd1': () => import('iconsax-react/dist/esm/MessageAdd1'),
	'MessageCircle': () => import('iconsax-react/dist/esm/MessageCircle'),
	'MessageEdit': () => import('iconsax-react/dist/esm/MessageEdit'),
	'MessageFavorite': () => import('iconsax-react/dist/esm/MessageFavorite'),
	'MessageMinus': () => import('iconsax-react/dist/esm/MessageMinus'),
	'MessageNotif': () => import('iconsax-react/dist/esm/MessageNotif'),
	'MessageProgramming': () => import('iconsax-react/dist/esm/MessageProgramming'),
	'MessageQuestion': () => import('iconsax-react/dist/esm/MessageQuestion'),
	'MessageRemove': () => import('iconsax-react/dist/esm/MessageRemove'),
	'MessageSearch': () => import('iconsax-react/dist/esm/MessageSearch'),
	'MessageSquare': () => import('iconsax-react/dist/esm/MessageSquare'),
	'MessageText': () => import('iconsax-react/dist/esm/MessageText'),
	'MessageText1': () => import('iconsax-react/dist/esm/MessageText1'),
	'MessageTick': () => import('iconsax-react/dist/esm/MessageTick'),
	'MessageTime': () => import('iconsax-react/dist/esm/MessageTime'),
	'Messages': () => import('iconsax-react/dist/esm/Messages'),
	'Messages1': () => import('iconsax-react/dist/esm/Messages1'),
	'Messages2': () => import('iconsax-react/dist/esm/Messages2'),
	'Messages3': () => import('iconsax-react/dist/esm/Messages3'),
	'Messenger': () => import('iconsax-react/dist/esm/Messenger'),
	'Microphone': () => import('iconsax-react/dist/esm/Microphone'),
	'Microphone2': () => import('iconsax-react/dist/esm/Microphone2'),
	'MicrophoneSlash': () => import('iconsax-react/dist/esm/MicrophoneSlash'),
	'MicrophoneSlash1': () => import('iconsax-react/dist/esm/MicrophoneSlash1'),
	'Microscope': () => import('iconsax-react/dist/esm/Microscope'),
	'Milk': () => import('iconsax-react/dist/esm/Milk'),
	'MiniMusicSqaure': () => import('iconsax-react/dist/esm/MiniMusicSqaure'),
	'Minus': () => import('iconsax-react/dist/esm/Minus'),
	'MinusCirlce': () => import('iconsax-react/dist/esm/MinusCirlce'),
	'MinusSquare': () => import('iconsax-react/dist/esm/MinusSquare'),
	'Mirror': () => import('iconsax-react/dist/esm/Mirror'),
	'MirroringScreen': () => import('iconsax-react/dist/esm/MirroringScreen'),
	'Mobile': () => import('iconsax-react/dist/esm/Mobile'),
	'MobileProgramming': () => import('iconsax-react/dist/esm/MobileProgramming'),
	'Monero': () => import('iconsax-react/dist/esm/Monero'),
	'Money': () => import('iconsax-react/dist/esm/Money'),
	'Money2': () => import('iconsax-react/dist/esm/Money2'),
	'Money3': () => import('iconsax-react/dist/esm/Money3'),
	'Money4': () => import('iconsax-react/dist/esm/Money4'),
	'MoneyAdd': () => import('iconsax-react/dist/esm/MoneyAdd'),
	'MoneyArchive': () => import('iconsax-react/dist/esm/MoneyArchive'),
	'MoneyChange': () => import('iconsax-react/dist/esm/MoneyChange'),
	'MoneyForbidden': () => import('iconsax-react/dist/esm/MoneyForbidden'),
	'MoneyRecive': () => import('iconsax-react/dist/esm/MoneyRecive'),
	'MoneyRemove': () => import('iconsax-react/dist/esm/MoneyRemove'),
	'MoneySend': () => import('iconsax-react/dist/esm/MoneySend'),
	'MoneyTick': () => import('iconsax-react/dist/esm/MoneyTick'),
	'MoneyTime': () => import('iconsax-react/dist/esm/MoneyTime'),
	'Moneys': () => import('iconsax-react/dist/esm/Moneys'),
	'Monitor': () => import('iconsax-react/dist/esm/Monitor'),
	'MonitorMobbile': () => import('iconsax-react/dist/esm/MonitorMobbile'),
	'MonitorRecorder': () => import('iconsax-react/dist/esm/MonitorRecorder'),
	'Moon': () => import('iconsax-react/dist/esm/Moon'),
	'More': () => import('iconsax-react/dist/esm/More'),
	'More2': () => import('iconsax-react/dist/esm/More2'),
	'MoreCircle': () => import('iconsax-react/dist/esm/MoreCircle'),
	'MoreSquare': () => import('iconsax-react/dist/esm/MoreSquare'),
	'Mouse': () => import('iconsax-react/dist/esm/Mouse'),
	'MouseCircle': () => import('iconsax-react/dist/esm/MouseCircle'),
	'MouseSquare': () => import('iconsax-react/dist/esm/MouseSquare'),
	'Music': () => import('iconsax-react/dist/esm/Music'),
	'MusicCircle': () => import('iconsax-react/dist/esm/MusicCircle'),
	'MusicDashboard': () => import('iconsax-react/dist/esm/MusicDashboard'),
	'MusicFilter': () => import('iconsax-react/dist/esm/MusicFilter'),
	'MusicLibrary2': () => import('iconsax-react/dist/esm/MusicLibrary2'),
	'MusicPlay': () => import('iconsax-react/dist/esm/MusicPlay'),
	'MusicPlaylist': () => import('iconsax-react/dist/esm/MusicPlaylist'),
	'MusicSquare': () => import('iconsax-react/dist/esm/MusicSquare'),
	'MusicSquareAdd': () => import('iconsax-react/dist/esm/MusicSquareAdd'),
	'MusicSquareRemove': () => import('iconsax-react/dist/esm/MusicSquareRemove'),
	'MusicSquareSearch': () => import('iconsax-react/dist/esm/MusicSquareSearch'),
	'Musicnote': () => import('iconsax-react/dist/esm/Musicnote'),
	'Nebulas': () => import('iconsax-react/dist/esm/Nebulas'),
	'Nem': () => import('iconsax-react/dist/esm/Nem'),
	'Nexo': () => import('iconsax-react/dist/esm/Nexo'),
	'Next': () => import('iconsax-react/dist/esm/Next'),
	'Note': () => import('iconsax-react/dist/esm/Note'),
	'Note1': () => import('iconsax-react/dist/esm/Note1'),
	'NoteAdd': () => import('iconsax-react/dist/esm/NoteAdd'),
	'NoteFavorite': () => import('iconsax-react/dist/esm/NoteFavorite'),
	'NoteRemove': () => import('iconsax-react/dist/esm/NoteRemove'),
	'NoteSquare': () => import('iconsax-react/dist/esm/NoteSquare'),
	'NoteText': () => import('iconsax-react/dist/esm/NoteText'),
	'Notepad': () => import('iconsax-react/dist/esm/Notepad'),
	'Notepad2': () => import('iconsax-react/dist/esm/Notepad2'),
	'Notification': () => import('iconsax-react/dist/esm/Notification'),
	'Notification1': () => import('iconsax-react/dist/esm/Notification1'),
	'NotificationBing': () => import('iconsax-react/dist/esm/NotificationBing'),
	'NotificationCircle': () => import('iconsax-react/dist/esm/NotificationCircle'),
	'NotificationFavorite': () => import('iconsax-react/dist/esm/NotificationFavorite'),
	'NotificationStatus': () => import('iconsax-react/dist/esm/NotificationStatus'),
	'OceanProtocol': () => import('iconsax-react/dist/esm/OceanProtocol'),
	'Okb': () => import('iconsax-react/dist/esm/Okb'),
	'Okru': () => import('iconsax-react/dist/esm/Okru'),
	'OmegaCircle': () => import('iconsax-react/dist/esm/OmegaCircle'),
	'OmegaSquare': () => import('iconsax-react/dist/esm/OmegaSquare'),
	'Ontology': () => import('iconsax-react/dist/esm/Ontology'),
	'Paintbucket': () => import('iconsax-react/dist/esm/Paintbucket'),
	'Paperclip': () => import('iconsax-react/dist/esm/Paperclip'),
	'Paperclip2': () => import('iconsax-react/dist/esm/Paperclip2'),
	'PasswordCheck': () => import('iconsax-react/dist/esm/PasswordCheck'),
	'PathTool': () => import('iconsax-react/dist/esm/PathTool'),
	'PathTool2': () => import('iconsax-react/dist/esm/PathTool2'),
	'PathToolSquare': () => import('iconsax-react/dist/esm/PathToolSquare'),
	'Pause': () => import('iconsax-react/dist/esm/Pause'),
	'PauseCircle': () => import('iconsax-react/dist/esm/PauseCircle'),
	'Paypal': () => import('iconsax-react/dist/esm/Paypal'),
	'PenAdd': () => import('iconsax-react/dist/esm/PenAdd'),
	'PenClose': () => import('iconsax-react/dist/esm/PenClose'),
	'PenRemove': () => import('iconsax-react/dist/esm/PenRemove'),
	'PenTool': () => import('iconsax-react/dist/esm/PenTool'),
	'PenTool2': () => import('iconsax-react/dist/esm/PenTool2'),
	'People': () => import('iconsax-react/dist/esm/People'),
	'PercentageCircle': () => import('iconsax-react/dist/esm/PercentageCircle'),
	'PercentageSquare': () => import('iconsax-react/dist/esm/PercentageSquare'),
	'Personalcard': () => import('iconsax-react/dist/esm/Personalcard'),
	'Pet': () => import('iconsax-react/dist/esm/Pet'),
	'Pharagraphspacing': () => import('iconsax-react/dist/esm/Pharagraphspacing'),
	'Photoshop': () => import('iconsax-react/dist/esm/Photoshop'),
	'PictureFrame': () => import('iconsax-react/dist/esm/PictureFrame'),
	'Play': () => import('iconsax-react/dist/esm/Play'),
	'PlayAdd': () => import('iconsax-react/dist/esm/PlayAdd'),
	'PlayCircle': () => import('iconsax-react/dist/esm/PlayCircle'),
	'PlayCricle': () => import('iconsax-react/dist/esm/PlayCricle'),
	'PlayRemove': () => import('iconsax-react/dist/esm/PlayRemove'),
	'Pointer': () => import('iconsax-react/dist/esm/Pointer'),
	'Polkadot': () => import('iconsax-react/dist/esm/Polkadot'),
	'Polygon': () => import('iconsax-react/dist/esm/Polygon'),
	'Polyswarm': () => import('iconsax-react/dist/esm/Polyswarm'),
	'PresentionChart': () => import('iconsax-react/dist/esm/PresentionChart'),
	'Previous': () => import('iconsax-react/dist/esm/Previous'),
	'Printer': () => import('iconsax-react/dist/esm/Printer'),
	'PrinterSlash': () => import('iconsax-react/dist/esm/PrinterSlash'),
	'Profile': () => import('iconsax-react/dist/esm/Profile'),
	'Profile2User': () => import('iconsax-react/dist/esm/Profile2User'),
	'ProfileAdd': () => import('iconsax-react/dist/esm/ProfileAdd'),
	'ProfileCircle': () => import('iconsax-react/dist/esm/ProfileCircle'),
	'ProfileDelete': () => import('iconsax-react/dist/esm/ProfileDelete'),
	'ProfileRemove': () => import('iconsax-react/dist/esm/ProfileRemove'),
	'ProfileTick': () => import('iconsax-react/dist/esm/ProfileTick'),
	'ProgrammingArrow': () => import('iconsax-react/dist/esm/ProgrammingArrow'),
	'ProgrammingArrows': () => import('iconsax-react/dist/esm/ProgrammingArrows'),
	'Python': () => import('iconsax-react/dist/esm/Python'),
	'Quant': () => import('iconsax-react/dist/esm/Quant'),
	'QuoteDown': () => import('iconsax-react/dist/esm/QuoteDown'),
	'QuoteDownCircle': () => import('iconsax-react/dist/esm/QuoteDownCircle'),
	'QuoteDownSquare': () => import('iconsax-react/dist/esm/QuoteDownSquare'),
	'QuoteUp': () => import('iconsax-react/dist/esm/QuoteUp'),
	'QuoteUpCircle': () => import('iconsax-react/dist/esm/QuoteUpCircle'),
	'QuoteUpSquare': () => import('iconsax-react/dist/esm/QuoteUpSquare'),
	'Radar': () => import('iconsax-react/dist/esm/Radar'),
	'Radar2': () => import('iconsax-react/dist/esm/Radar2'),
	'Radio': () => import('iconsax-react/dist/esm/Radio'),
	'Ram': () => import('iconsax-react/dist/esm/Ram'),
	'Ram2': () => import('iconsax-react/dist/esm/Ram2'),
	'Rank': () => import('iconsax-react/dist/esm/Rank'),
	'Ranking': () => import('iconsax-react/dist/esm/Ranking'),
	'Receipt': () => import('iconsax-react/dist/esm/Receipt'),
	'Receipt1': () => import('iconsax-react/dist/esm/Receipt1'),
	'Receipt2': () => import('iconsax-react/dist/esm/Receipt2'),
	'Receipt21': () => import('iconsax-react/dist/esm/Receipt21'),
	'ReceiptAdd': () => import('iconsax-react/dist/esm/ReceiptAdd'),
	'ReceiptDiscount': () => import('iconsax-react/dist/esm/ReceiptDiscount'),
	'ReceiptDisscount': () => import('iconsax-react/dist/esm/ReceiptDisscount'),
	'ReceiptEdit': () => import('iconsax-react/dist/esm/ReceiptEdit'),
	'ReceiptItem': () => import('iconsax-react/dist/esm/ReceiptItem'),
	'ReceiptMinus': () => import('iconsax-react/dist/esm/ReceiptMinus'),
	'ReceiptSearch': () => import('iconsax-react/dist/esm/ReceiptSearch'),
	'ReceiptSquare': () => import('iconsax-react/dist/esm/ReceiptSquare'),
	'ReceiptText': () => import('iconsax-react/dist/esm/ReceiptText'),
	'Receive': () => import('iconsax-react/dist/esm/Receive'),
	'ReceiveSquare': () => import('iconsax-react/dist/esm/ReceiveSquare'),
	'ReceiveSquare2': () => import('iconsax-react/dist/esm/ReceiveSquare2'),
	'Record': () => import('iconsax-react/dist/esm/Record'),
	'RecordCircle': () => import('iconsax-react/dist/esm/RecordCircle'),
	'RecoveryConvert': () => import('iconsax-react/dist/esm/RecoveryConvert'),
	'Refresh': () => import('iconsax-react/dist/esm/Refresh'),
	'Refresh2': () => import('iconsax-react/dist/esm/Refresh2'),
	'RefreshCircle': () => import('iconsax-react/dist/esm/RefreshCircle'),
	'RefreshLeftSquare': () => import('iconsax-react/dist/esm/RefreshLeftSquare'),
	'RefreshRightSquare': () => import('iconsax-react/dist/esm/RefreshRightSquare'),
	'RefreshSquare': () => import('iconsax-react/dist/esm/RefreshSquare'),
	'Repeat': () => import('iconsax-react/dist/esm/Repeat'),
	'RepeatCircle': () => import('iconsax-react/dist/esm/RepeatCircle'),
	'RepeateMusic': () => import('iconsax-react/dist/esm/RepeateMusic'),
	'RepeateOne': () => import('iconsax-react/dist/esm/RepeateOne'),
	'Reserve': () => import('iconsax-react/dist/esm/Reserve'),
	'RotateLeft': () => import('iconsax-react/dist/esm/RotateLeft'),
	'RotateRight': () => import('iconsax-react/dist/esm/RotateRight'),
	'RouteSquare': () => import('iconsax-react/dist/esm/RouteSquare'),
	'Routing': () => import('iconsax-react/dist/esm/Routing'),
	'Routing2': () => import('iconsax-react/dist/esm/Routing2'),
	'RowHorizontal': () => import('iconsax-react/dist/esm/RowHorizontal'),
	'RowVertical': () => import('iconsax-react/dist/esm/RowVertical'),
	'Ruler': () => import('iconsax-react/dist/esm/Ruler'),
	'RulerPen': () => import('iconsax-react/dist/esm/RulerPen'),
	'SafeHome': () => import('iconsax-react/dist/esm/SafeHome'),
	'Sagittarius': () => import('iconsax-react/dist/esm/Sagittarius'),
	'Save2': () => import('iconsax-react/dist/esm/Save2'),
	'SaveAdd': () => import('iconsax-react/dist/esm/SaveAdd'),
	'SaveMinus': () => import('iconsax-react/dist/esm/SaveMinus'),
	'SaveRemove': () => import('iconsax-react/dist/esm/SaveRemove'),
	'Scan': () => import('iconsax-react/dist/esm/Scan'),
	'ScanBarcode': () => import('iconsax-react/dist/esm/ScanBarcode'),
	'Scanner': () => import('iconsax-react/dist/esm/Scanner'),
	'Scanning': () => import('iconsax-react/dist/esm/Scanning'),
	'Scissor': () => import('iconsax-react/dist/esm/Scissor'),
	'Screenmirroring': () => import('iconsax-react/dist/esm/Screenmirroring'),
	'Scroll': () => import('iconsax-react/dist/esm/Scroll'),
	'SearchFavorite': () => import('iconsax-react/dist/esm/SearchFavorite'),
	'SearchFavorite1': () => import('iconsax-react/dist/esm/SearchFavorite1'),
	'SearchNormal': () => import('iconsax-react/dist/esm/SearchNormal'),
	'SearchNormal1': () => import('iconsax-react/dist/esm/SearchNormal1'),
	'SearchStatus': () => import('iconsax-react/dist/esm/SearchStatus'),
	'SearchStatus1': () => import('iconsax-react/dist/esm/SearchStatus1'),
	'SearchZoomIn': () => import('iconsax-react/dist/esm/SearchZoomIn'),
	'SearchZoomIn1': () => import('iconsax-react/dist/esm/SearchZoomIn1'),
	'SearchZoomOut': () => import('iconsax-react/dist/esm/SearchZoomOut'),
	'SearchZoomOut1': () => import('iconsax-react/dist/esm/SearchZoomOut1'),
	'Security': () => import('iconsax-react/dist/esm/Security'),
	'SecurityCard': () => import('iconsax-react/dist/esm/SecurityCard'),
	'SecuritySafe': () => import('iconsax-react/dist/esm/SecuritySafe'),
	'SecurityTime': () => import('iconsax-react/dist/esm/SecurityTime'),
	'SecurityUser': () => import('iconsax-react/dist/esm/SecurityUser'),
	'Send': () => import('iconsax-react/dist/esm/Send'),
	'Send2': () => import('iconsax-react/dist/esm/Send2'),
	'Setting': () => import('iconsax-react/dist/esm/Setting'),
	'Setting2': () => import('iconsax-react/dist/esm/Setting2'),
	'Setting3': () => import('iconsax-react/dist/esm/Setting3'),
	'Setting4': () => import('iconsax-react/dist/esm/Setting4'),
	'Setting5': () => import('iconsax-react/dist/esm/Setting5'),
	'Settings': () => import('iconsax-react/dist/esm/Settings'),
	'Shapes': () => import('iconsax-react/dist/esm/Shapes'),
	'Shapes1': () => import('iconsax-react/dist/esm/Shapes1'),
	'Share': () => import('iconsax-react/dist/esm/Share'),
	'Shield': () => import('iconsax-react/dist/esm/Shield'),
	'ShieldCross': () => import('iconsax-react/dist/esm/ShieldCross'),
	'ShieldSearch': () => import('iconsax-react/dist/esm/ShieldSearch'),
	'ShieldSecurity': () => import('iconsax-react/dist/esm/ShieldSecurity'),
	'ShieldSlash': () => import('iconsax-react/dist/esm/ShieldSlash'),
	'ShieldTick': () => import('iconsax-react/dist/esm/ShieldTick'),
	'Ship': () => import('iconsax-react/dist/esm/Ship'),
	'Shop': () => import('iconsax-react/dist/esm/Shop'),
	'ShopAdd': () => import('iconsax-react/dist/esm/ShopAdd'),
	'ShopRemove': () => import('iconsax-react/dist/esm/ShopRemove'),
	'ShoppingBag': () => import('iconsax-react/dist/esm/ShoppingBag'),
	'ShoppingCart': () => import('iconsax-react/dist/esm/ShoppingCart'),
	'Shuffle': () => import('iconsax-react/dist/esm/Shuffle'),
	'Shutterstock': () => import('iconsax-react/dist/esm/Shutterstock'),
	'Siacoin': () => import('iconsax-react/dist/esm/Siacoin'),
	'SidebarBottom': () => import('iconsax-react/dist/esm/SidebarBottom'),
	'SidebarLeft': () => import('iconsax-react/dist/esm/SidebarLeft'),
	'SidebarRight': () => import('iconsax-react/dist/esm/SidebarRight'),
	'SidebarTop': () => import('iconsax-react/dist/esm/SidebarTop'),
	'Signpost': () => import('iconsax-react/dist/esm/Signpost'),
	'Simcard': () => import('iconsax-react/dist/esm/Simcard'),
	'Simcard1': () => import('iconsax-react/dist/esm/Simcard1'),
	'Simcard2': () => import('iconsax-react/dist/esm/Simcard2'),
	'Size': () => import('iconsax-react/dist/esm/Size'),
	'Slack': () => import('iconsax-react/dist/esm/Slack'),
	'Slash': () => import('iconsax-react/dist/esm/Slash'),
	'Slider': () => import('iconsax-react/dist/esm/Slider'),
	'SliderHorizontal': () => import('iconsax-react/dist/esm/SliderHorizontal'),
	'SliderHorizontal1': () => import('iconsax-react/dist/esm/SliderHorizontal1'),
	'SliderVertical': () => import('iconsax-react/dist/esm/SliderVertical'),
	'SliderVertical1': () => import('iconsax-react/dist/esm/SliderVertical1'),
	'Smallcaps': () => import('iconsax-react/dist/esm/Smallcaps'),
	'SmartCar': () => import('iconsax-react/dist/esm/SmartCar'),
	'SmartHome': () => import('iconsax-react/dist/esm/SmartHome'),
	'Smileys': () => import('iconsax-react/dist/esm/Smileys'),
	'Sms': () => import('iconsax-react/dist/esm/Sms'),
	'SmsEdit': () => import('iconsax-react/dist/esm/SmsEdit'),
	'SmsNotification': () => import('iconsax-react/dist/esm/SmsNotification'),
	'SmsSearch': () => import('iconsax-react/dist/esm/SmsSearch'),
	'SmsStar': () => import('iconsax-react/dist/esm/SmsStar'),
	'SmsTracking': () => import('iconsax-react/dist/esm/SmsTracking'),
	'Snapchat': () => import('iconsax-react/dist/esm/Snapchat'),
	'Solana': () => import('iconsax-react/dist/esm/Solana'),
	'Sort': () => import('iconsax-react/dist/esm/Sort'),
	'Sound': () => import('iconsax-react/dist/esm/Sound'),
	'Speaker': () => import('iconsax-react/dist/esm/Speaker'),
	'Speedometer': () => import('iconsax-react/dist/esm/Speedometer'),
	'Spotify': () => import('iconsax-react/dist/esm/Spotify'),
	'Stacks': () => import('iconsax-react/dist/esm/Stacks'),
	'Star': () => import('iconsax-react/dist/esm/Star'),
	'Star1': () => import('iconsax-react/dist/esm/Star1'),
	'StarSlash': () => import('iconsax-react/dist/esm/StarSlash'),
	'Status': () => import('iconsax-react/dist/esm/Status'),
	'StatusUp': () => import('iconsax-react/dist/esm/StatusUp'),
	'Stellar': () => import('iconsax-react/dist/esm/Stellar'),
	'Sticker': () => import('iconsax-react/dist/esm/Sticker'),
	'Stickynote': () => import('iconsax-react/dist/esm/Stickynote'),
	'Stop': () => import('iconsax-react/dist/esm/Stop'),
	'StopCircle': () => import('iconsax-react/dist/esm/StopCircle'),
	'Story': () => import('iconsax-react/dist/esm/Story'),
	'Strongbox': () => import('iconsax-react/dist/esm/Strongbox'),
	'Strongbox2': () => import('iconsax-react/dist/esm/Strongbox2'),
	'Subtitle': () => import('iconsax-react/dist/esm/Subtitle'),
	'Sun': () => import('iconsax-react/dist/esm/Sun'),
	'Sun1': () => import('iconsax-react/dist/esm/Sun1'),
	'SunFog': () => import('iconsax-react/dist/esm/SunFog'),
	'TableDocument': () => import('iconsax-react/dist/esm/TableDocument'),
	'TableLamp': () => import('iconsax-react/dist/esm/TableLamp'),
	'Tag': () => import('iconsax-react/dist/esm/Tag'),
	'Tag2': () => import('iconsax-react/dist/esm/Tag2'),
	'TagCross': () => import('iconsax-react/dist/esm/TagCross'),
	'TagRight': () => import('iconsax-react/dist/esm/TagRight'),
	'TagUser': () => import('iconsax-react/dist/esm/TagUser'),
	'Task': () => import('iconsax-react/dist/esm/Task'),
	'TaskSquare': () => import('iconsax-react/dist/esm/TaskSquare'),
	'Teacher': () => import('iconsax-react/dist/esm/Teacher'),
	'Tenx': () => import('iconsax-react/dist/esm/Tenx'),
	'Tether': () => import('iconsax-react/dist/esm/Tether'),
	'Text': () => import('iconsax-react/dist/esm/Text'),
	'TextBlock': () => import('iconsax-react/dist/esm/TextBlock'),
	'TextBold': () => import('iconsax-react/dist/esm/TextBold'),
	'TextItalic': () => import('iconsax-react/dist/esm/TextItalic'),
	'TextUnderline': () => import('iconsax-react/dist/esm/TextUnderline'),
	'TextalignCenter': () => import('iconsax-react/dist/esm/TextalignCenter'),
	'TextalignJustifycenter': () => import('iconsax-react/dist/esm/TextalignJustifycenter'),
	'TextalignJustifyleft': () => import('iconsax-react/dist/esm/TextalignJustifyleft'),
	'TextalignJustifyright': () => import('iconsax-react/dist/esm/TextalignJustifyright'),
	'TextalignLeft': () => import('iconsax-react/dist/esm/TextalignLeft'),
	'TextalignRight': () => import('iconsax-react/dist/esm/TextalignRight'),
	'TheGraph': () => import('iconsax-react/dist/esm/TheGraph'),
	'Theta': () => import('iconsax-react/dist/esm/Theta'),
	'Thorchain': () => import('iconsax-react/dist/esm/Thorchain'),
	'TickCircle': () => import('iconsax-react/dist/esm/TickCircle'),
	'TickSquare': () => import('iconsax-react/dist/esm/TickSquare'),
	'Ticket': () => import('iconsax-react/dist/esm/Ticket'),
	'Ticket2': () => import('iconsax-react/dist/esm/Ticket2'),
	'TicketDiscount': () => import('iconsax-react/dist/esm/TicketDiscount'),
	'TicketExpired': () => import('iconsax-react/dist/esm/TicketExpired'),
	'TicketStar': () => import('iconsax-react/dist/esm/TicketStar'),
	'Timer': () => import('iconsax-react/dist/esm/Timer'),
	'Timer1': () => import('iconsax-react/dist/esm/Timer1'),
	'TimerPause': () => import('iconsax-react/dist/esm/TimerPause'),
	'TimerStart': () => import('iconsax-react/dist/esm/TimerStart'),
	'ToggleOff': () => import('iconsax-react/dist/esm/ToggleOff'),
	'ToggleOffCircle': () => import('iconsax-react/dist/esm/ToggleOffCircle'),
	'ToggleOn': () => import('iconsax-react/dist/esm/ToggleOn'),
	'ToggleOnCircle': () => import('iconsax-react/dist/esm/ToggleOnCircle'),
	'Trade': () => import('iconsax-react/dist/esm/Trade'),
	'TransactionMinus': () => import('iconsax-react/dist/esm/TransactionMinus'),
	'Translate': () => import('iconsax-react/dist/esm/Translate'),
	'Transmit': () => import('iconsax-react/dist/esm/Transmit'),
	'TransmitSqaure2': () => import('iconsax-react/dist/esm/TransmitSqaure2'),
	'TransmitSquare': () => import('iconsax-react/dist/esm/TransmitSquare'),
	'Trash': () => import('iconsax-react/dist/esm/Trash'),
	'Tree': () => import('iconsax-react/dist/esm/Tree'),
	'Trello': () => import('iconsax-react/dist/esm/Trello'),
	'TrendDown': () => import('iconsax-react/dist/esm/TrendDown'),
	'TrendUp': () => import('iconsax-react/dist/esm/TrendUp'),
	'Triangle': () => import('iconsax-react/dist/esm/Triangle'),
	'TriangleLogo': () => import('iconsax-react/dist/esm/TriangleLogo'),
	'Trontron': () => import('iconsax-react/dist/esm/Trontron'),
	'Truck': () => import('iconsax-react/dist/esm/Truck'),
	'TruckFast': () => import('iconsax-react/dist/esm/TruckFast'),
	'TruckRemove': () => import('iconsax-react/dist/esm/TruckRemove'),
	'TruckTick': () => import('iconsax-react/dist/esm/TruckTick'),
	'TruckTime': () => import('iconsax-react/dist/esm/TruckTime'),
	'TrushSquare': () => import('iconsax-react/dist/esm/TrushSquare'),
	'Twitch': () => import('iconsax-react/dist/esm/Twitch'),
	'Ui8': () => import('iconsax-react/dist/esm/Ui8'),
	'Unlimited': () => import('iconsax-react/dist/esm/Unlimited'),
	'Unlock': () => import('iconsax-react/dist/esm/Unlock'),
	'UsdCoin': () => import('iconsax-react/dist/esm/UsdCoin'),
	'User': () => import('iconsax-react/dist/esm/User'),
	'UserAdd': () => import('iconsax-react/dist/esm/UserAdd'),
	'UserCirlceAdd': () => import('iconsax-react/dist/esm/UserCirlceAdd'),
	'UserEdit': () => import('iconsax-react/dist/esm/UserEdit'),
	'UserMinus': () => import('iconsax-react/dist/esm/UserMinus'),
	'UserOctagon': () => import('iconsax-react/dist/esm/UserOctagon'),
	'UserRemove': () => import('iconsax-react/dist/esm/UserRemove'),
	'UserSearch': () => import('iconsax-react/dist/esm/UserSearch'),
	'UserSquare': () => import('iconsax-react/dist/esm/UserSquare'),
	'UserTag': () => import('iconsax-react/dist/esm/UserTag'),
	'UserTick': () => import('iconsax-react/dist/esm/UserTick'),
	'Velas': () => import('iconsax-react/dist/esm/Velas'),
	'Verify': () => import('iconsax-react/dist/esm/Verify'),
	'Vibe': () => import('iconsax-react/dist/esm/Vibe'),
	'Video': () => import('iconsax-react/dist/esm/Video'),
	'VideoAdd': () => import('iconsax-react/dist/esm/VideoAdd'),
	'VideoCircle': () => import('iconsax-react/dist/esm/VideoCircle'),
	'VideoHorizontal': () => import('iconsax-react/dist/esm/VideoHorizontal'),
	'VideoOctagon': () => import('iconsax-react/dist/esm/VideoOctagon'),
	'VideoPlay': () => import('iconsax-react/dist/esm/VideoPlay'),
	'VideoRemove': () => import('iconsax-react/dist/esm/VideoRemove'),
	'VideoSlash': () => import('iconsax-react/dist/esm/VideoSlash'),
	'VideoSquare': () => import('iconsax-react/dist/esm/VideoSquare'),
	'VideoTick': () => import('iconsax-react/dist/esm/VideoTick'),
	'VideoTime': () => import('iconsax-react/dist/esm/VideoTime'),
	'VideoVertical': () => import('iconsax-react/dist/esm/VideoVertical'),
	'VoiceCricle': () => import('iconsax-react/dist/esm/VoiceCricle'),
	'VoiceSquare': () => import('iconsax-react/dist/esm/VoiceSquare'),
	'Volume': () => import('iconsax-react/dist/esm/Volume'),
	'VolumeCross': () => import('iconsax-react/dist/esm/VolumeCross'),
	'VolumeHigh': () => import('iconsax-react/dist/esm/VolumeHigh'),
	'VolumeLow': () => import('iconsax-react/dist/esm/VolumeLow'),
	'VolumeLow1': () => import('iconsax-react/dist/esm/VolumeLow1'),
	'VolumeMute': () => import('iconsax-react/dist/esm/VolumeMute'),
	'VolumeSlash': () => import('iconsax-react/dist/esm/VolumeSlash'),
	'VolumeUp': () => import('iconsax-react/dist/esm/VolumeUp'),
	'Wallet': () => import('iconsax-react/dist/esm/Wallet'),
	'Wallet1': () => import('iconsax-react/dist/esm/Wallet1'),
	'Wallet2': () => import('iconsax-react/dist/esm/Wallet2'),
	'Wallet3': () => import('iconsax-react/dist/esm/Wallet3'),
	'WalletAdd': () => import('iconsax-react/dist/esm/WalletAdd'),
	'WalletAdd1': () => import('iconsax-react/dist/esm/WalletAdd1'),
	'WalletCheck': () => import('iconsax-react/dist/esm/WalletCheck'),
	'WalletMinus': () => import('iconsax-react/dist/esm/WalletMinus'),
	'WalletMoney': () => import('iconsax-react/dist/esm/WalletMoney'),
	'WalletRemove': () => import('iconsax-react/dist/esm/WalletRemove'),
	'WalletSearch': () => import('iconsax-react/dist/esm/WalletSearch'),
	'Wanchain': () => import('iconsax-react/dist/esm/Wanchain'),
	'Wanchain1': () => import('iconsax-react/dist/esm/Wanchain1'),
	'Warning2': () => import('iconsax-react/dist/esm/Warning2'),
	'Watch': () => import('iconsax-react/dist/esm/Watch'),
	'WatchStatus': () => import('iconsax-react/dist/esm/WatchStatus'),
	'Weight': () => import('iconsax-react/dist/esm/Weight'),
	'WeightMeter': () => import('iconsax-react/dist/esm/WeightMeter'),
	'Whatsapp': () => import('iconsax-react/dist/esm/Whatsapp'),
	'Wifi': () => import('iconsax-react/dist/esm/Wifi'),
	'WifiSquare': () => import('iconsax-react/dist/esm/WifiSquare'),
	'Wind': () => import('iconsax-react/dist/esm/Wind'),
	'Wind2': () => import('iconsax-react/dist/esm/Wind2'),
	'Windows': () => import('iconsax-react/dist/esm/Windows'),
	'Wing': () => import('iconsax-react/dist/esm/Wing'),
	'Woman': () => import('iconsax-react/dist/esm/Woman'),
	'WristClock': () => import('iconsax-react/dist/esm/WristClock'),
	'Xd': () => import('iconsax-react/dist/esm/Xd'),
	'Xiaomi': () => import('iconsax-react/dist/esm/Xiaomi'),
	'Xrp': () => import('iconsax-react/dist/esm/Xrp'),
	'Youtube': () => import('iconsax-react/dist/esm/Youtube'),
	'Zel': () => import('iconsax-react/dist/esm/Zel'),
	'Zoom': () => import('iconsax-react/dist/esm/Zoom'),
	'index': () => import('iconsax-react/dist/esm/index')
};

const getDynamicIconsax = (iconName: string) => {
	const iconLoader = iconMap[iconName];
	if (!iconLoader) {
		return loadable(() => import('iconsax-react/dist/esm/Activity'));
	}
	return loadable(iconLoader);
};

export const DynamicIconsax: React.FC<DynamicIconsaxProps> = ({
	iconName,
	variant = 'Linear',
	size = 24,
	color = 'currentColor'
}) => {
	const IconComponent = getDynamicIconsax(iconName);

	return (
		<span>
			<IconComponent
				variant={variant}
				size={size}
				color={color}
			/>
		</span>
	);
};